import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './DrawerLevel.scss';
import { getAllowedAttributes } from '../../props-filters';

var ANIMATION_DURATION = 500;

var DrawerLevel = function (_Component) {
  _inherits(DrawerLevel, _Component);

  function DrawerLevel() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DrawerLevel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DrawerLevel.__proto__ || _Object$getPrototypeOf(DrawerLevel)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: _this.props.active
    }, _this.changeOpenState = function (open) {
      _this.setState({ open: open }, function () {
        if (open) {
          window.requestAnimationFrame(function () {
            return _this.requestAdjustHeight(_this.node);
          });
        }
      });
    }, _this.handleGoUp = function (event) {
      if (event.target === event.currentTarget || event.target === _this.node) {
        event.stopPropagation();
        if (!_this.props.below) return;
        _this.props.drawerUtils.goUpTo(_this.props.parentPath);
      }
    }, _this.storeRef = function (node) {
      _this.node = node;
    }, _this.requestAdjustHeight = function (node) {
      var adjustHeight = _this.props.drawerUtils.adjustHeight;

      if (node) {
        adjustHeight(node.scrollHeight);
      } else {
        adjustHeight();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DrawerLevel, [{
    key: 'UNSAFE_componentWillReceiveProps',


    // eslint-disable-next-line camelcase
    value: function UNSAFE_componentWillReceiveProps(_ref2) {
      var _this2 = this;

      var active = _ref2.active;

      if (active === this.props.active) {
        return;
      }
      if (active) {
        if (this.scheduledClose) {
          clearTimeout(this.scheduledClose);
        }
        this.changeOpenState(active);
      } else {
        this.requestAdjustHeight();
        this.scheduledClose = setTimeout(function () {
          _this2.changeOpenState(active);
        }, ANIMATION_DURATION);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.scheduledClose) clearTimeout(this.scheduledClose);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          active = _props.active,
          below = _props.below,
          restProps = _objectWithoutProperties(_props, ['children', 'className', 'active', 'below']);

      var open = this.state.open;

      var classNames = cx({
        'sb-header-drawer-sub-level': true,
        'sb-header-drawer-sub-level--active': active
      }, className);

      return React.createElement(
        'div',
        _extends({ className: classNames, onClick: this.handleGoUp }, getAllowedAttributes(restProps)),
        open && React.createElement(
          'ul',
          {
            className: cx({
              'sb-header-drawer-sub-level__content': true,
              'sb-header-drawer-sub-level__content--below': below
            }),
            ref: this.storeRef
          },
          children
        )
      );
    }
  }]);

  return DrawerLevel;
}(Component);

DrawerLevel.propTypes = {
  below: PropTypes.bool,
  active: PropTypes.bool,
  // @fixme: circular dependency on DrawerItem and DrawerGroup component
  // childrenOf(or([elementType(Item), elementType(Group)])),
  children: PropTypes.node,
  parentPath: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
  drawerUtils: PropTypes.shape({
    toggleActive: PropTypes.func.isRequired,
    goUpTo: PropTypes.func.isRequired,
    adjustHeight: PropTypes.func.isRequired,
    isActive: PropTypes.func.isRequired,
    isLevelBelow: PropTypes.func.isRequired
  }).isRequired
};
export default DrawerLevel;
//# sourceMappingURL=DrawerLevel.js.map